
import SinglePageTab from "./pages/SinglePageTab";
function App() {
  return (
    <div className="App">
      <SinglePageTab />
    </div>
  );
}

export default App;
